import React, { useEffect, useReducer, useState } from "react";
import SocialServiceContext from "./Context";
import { getCitizen } from "services/citizen";
import { getCitizenCanRedeem } from "services/citizen";
import { useQrScannerContext } from "pages/QRScan/Context";
import { useMatch } from "react-router-dom";

const defaultState = {
  citizen: null,
  canRedeem: false,
  isLoading: true,
};

const reducer = (state, action) => {
  switch (action.type) {
    case "SET_CITIZEN":
      return { ...state, citizen: action.citizen, isLoading: false};
    case "SET_CAN_REDEEM":
      return { ...state, canRedeem: action.canRedeem };
    case "SET_IS_LOADING":
      return { ...state, isLoading: action.isLoading };
    default:
      return state;
  }
};

const SocialServiceProvider = ({ children }) => {
  const [state, dispatch] = useReducer(reducer, defaultState);
  const { user } = useQrScannerContext();
  const matchCitizen = useMatch("/citizen/:id");
  const matchRedeem = useMatch("/citizen/:id/redeem");
  const id = matchCitizen?.params?.id || matchRedeem?.params?.id || null;
  useEffect(() => {
    if (!id || !user?.id || state.citizen) return;

    getCitizen(id).then(citizen => {
      dispatch({ type: "SET_CITIZEN", citizen });
    });

    getCitizenCanRedeem(id, user.id).then(canRedeem => {
      dispatch({ type: "SET_CAN_REDEEM", canRedeem });
    });
  }, [id, user?.id, state.citizen, dispatch]);
  return (
    <SocialServiceContext.Provider
      value={{
        citizen: state.citizen,
        canRedeem: state.canRedeem,
        isLoading: state.isLoading,
        dispatch,
      }}>
      {children}
    </SocialServiceContext.Provider>
  );
};

export default SocialServiceProvider;
